// removed by extract-text-webpack-plugin
module.exports = {"container":"_1GwyY _7mR3c","banquetLogo":"_3VKkd"};


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/AccountSettingsContainer/index.sass
// module id = 1515
// module chunks = 1